export default __webpack_public_path__ + "static/14-cfddc34b37fe5e97489a0c30440291e6.webp";